import React,{ useState } from "react";
import "./Options.css";
import { undo, redo, info } from "../../../assets/icons";
import { RoleName, NameOnly, Songs, Logos, Blurb } from "./OptionBlocks";
import { useSelector, useDispatch } from "react-redux";
import {redoOptions, undoOptions} from "../../../Redux/actions/projectActions";
import OptionFont from "./OptionFont/OptionFont";
import { selectedOption } from "../../../Redux/actions/commonActtion";
import { useNavigate } from "react-router-dom";

const getBlockName = (blockType) => {
  switch (blockType?.toLowerCase()) {
    case "rolename":
      return "Role + Name";
    case "nameonly":
      return "Name Only";
    case "logo":
      return "Logos";
    case "blurb":
      return "Blurb";
    case "song":
      return "Songs";
    default:
      return "Name Only";
  }
};

const getOptionBlock = (
  options,
  currentBlockIdx,
  currentBlockId,
  undoStack,
  setReLoading
) => {
  switch (options.block_type?.toLowerCase()) {
    case "rolename":
      return (
        <RoleName
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
        />
      );
    case "nameonly":
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
        />
      );
    case "logo":
      return (
        <Logos
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          setReLoading={setReLoading}
        />
      );
    case "blurb":
      return (
        <Blurb
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
        />
      );
    case "song":
      return (
        <Songs
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
        />
      );
    default:
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
        />
      );
  }
};

const Options = ({ currentBlockOptions, currentBlockIdx, currentBlockId ,setReLoading, isOptionSelected}) => {
  const [selected, setSelected] = useState("options");
  const objectMap = useSelector((state) => state.undoRedo);
  const undoStack = objectMap[currentBlockIdx]?.obj;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = "66e14a11eedf1bfc39f94b39";

  const OptionHandler = (val)=>{
    dispatch(selectedOption(val))
  }

  return (
    <div className="Layout">

      <div className="Layout-title">
        <div
          className={
            "layout-text " + (selected === "options" ? "selected" : "")
          }
          onClick={() => {
            if (selected === "fonts"){ setSelected("options"); OptionHandler('layout')}
          }}
        >
          <span>Layout</span>
        </div>
        <div
          className={"layout-text " + (selected === "fonts" ? "selected" : "")}
          onClick={() => {
            if (selected === "options") {setSelected("fonts"); OptionHandler('font')}            
          }}
        >
          <span>Font</span>
        </div>
        {/* <div className="undo-redo">
          {objectMap[currentBlockIdx]?.obj && (
            <>
              <button
                disabled={undoStack.getPosition < 1}
                onClick={() => dispatch(undoOptions(currentBlockId))}
              >
                <img src={undo} alt="" />
              </button>
              <button
                disabled={
                  undoStack.getPosition === -1 ||
                  undoStack.getPosition === undoStack.getData.length - 1
                }
                onClick={() => dispatch(redoOptions(currentBlockId))}
              >
                <img src={redo} alt="" style={{ color: "white" }} />
              </button>
            </>
          )}
        </div> */}
      </div>

      <div className="Layout-screen">
        <div className="Block-type">
          <div className="Block-text">
            <span>Block type</span>
          </div>
          <div className="Block-name">
            <div><span>{getBlockName(currentBlockOptions.block_type)}</span></div>
            {/* <div><img src={info} alt="" style={{cursor:'pointer'}} onClick={()=>window.open(`/help`)}/></div> */}

            {selected === "fonts" ? 
            (<div><img src={info} alt="" style={{cursor:'pointer'}} onClick={()=>window.open(`/help/66fd235c676b1a05d82daf44`)}/></div>)
            :
            (<div><img src={info} alt="" style={{cursor:'pointer'}} onClick={()=>window.open(`/help/66fd093d676b1a05d82daadc`)}/></div>)}
          </div>
          
        </div>
        {/* <hr /> */}
        {selected === "options" ? (
          <div className="Mainlayout-screen">
            {getOptionBlock(
              currentBlockOptions,
              currentBlockIdx,
              currentBlockId,
              undoStack,
              setReLoading
            )}
          </div>
        ) : (
          <div className="Mainlayout-screen">
            <OptionFont />
          </div>
        )}
      </div>
    </div>
  );
};

export default Options;
